import consumer from "./consumer"

// Prevent duplicate subscriptions
if (!window.printChannelSubscription) {
  window.printChannelSubscription = consumer.subscriptions.create("PrintChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("Connected to PrintChannel");
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
    console.log("Disconnected from PrintChannel");
  },

  received(data) {
    console.log('Received print data:', data);
    
    // Only execute printing logic if we're on the print page
    if (window.location.pathname.includes('/print')) {
      console.log('Print page detected - executing print logic');
      
      // Add to print queue
      if (typeof addToQueue === 'function') {
        addToQueue(data);
      }
      
      // Show badge preview
      if (typeof showBadgePreview === 'function') {
        showBadgePreview(data);
      }

      // Create PDF definition for printing
      let docDefinition = {
        pageSize: {
          width: 200,
          height: 125
        },
        pageMargins: 5,
        content: [],
        styles: {
          name: {
            fontSize: 16,
            bold: true,
            alignment: 'center'
          },
          company: {
            fontSize: 14,
            bold: false,
            alignment: 'center'
          }
        }
      };

      let attendant = {
        text: '',
        style: 'name',
        margin: [0, 15, 0, 0]
      };

      let organisation = {
        text: '',
        style: 'company',
        margin: [0, 10, 0, 0]
      };

      attendant.text = data.name.toUpperCase();
      organisation.text = data.company.toUpperCase();
      docDefinition.content.push(attendant);
      docDefinition.content.push(organisation);
      
      console.log('Printing badge for:', data.name);
      
      // Print the badge
      pdfMake.createPdf(docDefinition).print();
      
      // Update queue item status to printed
      setTimeout(() => {
        // Mark the latest item as printed
        if (typeof printQueue !== 'undefined' && printQueue.length > 0) {
          const latestItem = printQueue[printQueue.length - 1];
          if (latestItem.name === data.name) {
            latestItem.status = 'printed';
            if (typeof updateQueueDisplay === 'function') {
              updateQueueDisplay();
            }
          }
        }
      }, 2000); // Wait 2 seconds after printing
    } else {
      console.log('Not on print page - ignoring print data');
    }
  }
  });
}
